import { RequestPrintFormsVars } from '../../../types/themeTypes';

const actionIconSize = 20;
const actionIconFontSize = 13;

export default {
    actionIconSize,
    actionIconFontSize,
} as RequestPrintFormsVars;
